var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSacola(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5002 6.49984H19.3335C19.3335 3.00067 16.4993 0.166504 13.0002 0.166504C9.501 0.166504 6.66683 3.00067 6.66683 6.49984H3.50016C1.7585 6.49984 0.333496 7.92484 0.333496 9.6665V28.6665C0.333496 30.4082 1.7585 31.8332 3.50016 31.8332H22.5002C24.2418 31.8332 25.6668 30.4082 25.6668 28.6665V9.6665C25.6668 7.92484 24.2418 6.49984 22.5002 6.49984ZM13.0002 3.33317C14.7418 3.33317 16.1668 4.75817 16.1668 6.49984H9.8335C9.8335 4.75817 11.2585 3.33317 13.0002 3.33317ZM22.5002 28.6665H3.50016V9.6665H6.66683V12.8332C6.66683 13.704 7.37933 14.4165 8.25016 14.4165C9.121 14.4165 9.8335 13.704 9.8335 12.8332V9.6665H16.1668V12.8332C16.1668 13.704 16.8793 14.4165 17.7502 14.4165C18.621 14.4165 19.3335 13.704 19.3335 12.8332V9.6665H22.5002V28.6665Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSacola);
export default __webpack_public_path__ + "static/media/sacola.64ac027d4d73f3b7b4af9ad800c1225c.svg";
export { ForwardRef as ReactComponent };